import { AODA } from '@core/utilities/aoda';
import { ChangeDetectionStrategy, Component, ElementRef, Injector, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { DrillHole } from '@shared/models/records/drill-hole.model';
import { ElasticSearchQueryBody } from '@shared/models/common/elasticsearch-query-body.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable, of, takeWhile, tap } from 'rxjs';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: "app-drill-hole-record",
  templateUrl: "./drill-hole-record.component.html",
  styleUrls: ["./drill-hole-record.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrillHoleRecordComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  record: DrillHole;
  searchTerms: string;
  drillHoles$: Observable<any[]>;

  // Overlay spinner configuration
  color = 'accent';
  mode = 'indeterminate';
  value = 50;
  displayProgressSpinner = false;
  spinnerWithoutBackdrop = false;

  constructor(
    private injector: Injector,
    private route: ActivatedRoute,
    private el: ElementRef,
    private r2: Renderer2,
    private http: HttpClient
  ) {
    super(injector);
  }

  ngOnInit() {
    this.initRecord();
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  private initRecord() {
    if (!history.state.data) {
      this.record = JSON.parse(this.searchResultsCache.getRecord());
    } else {
      this.record = history.state.data;
      this.searchTerms = history.state.searchTerms;
      this.searchResultsCache.setRecord(this.record);
    }

    this.findRelatedDrillHoles();

    const breadcrumb = {
      name: this.tech_id,
      prefix: "summary",
      component: "DrillHoleRecordComponent",
    };
    this.breadcrumbService.addBreadcrumb(breadcrumb);
  }

  get company() {
    return this.record.company_name;
  }

  get propertyName() {
    return this.record.property_name;
  }

  get township() {
    return this.record.township;
  }

  get nts() {
    return this.record.nts_num;
  }

  get rgpDistrict() {
    return this.record.rgp_district;
  }

  get yearDrilled() {
    return this.record.year_drilled;
  }

  get tech_id() {
    return this.record.tech_id;
  }

  get contact_rgp() {
    return this.record.contact_rgp[0];
  }

  get databaseIndex(): string {
    return DatabaseIndexNameType.drillHoles;
  }

  get assessmentPersistentLink(): string {
    return environment.application_url + "persistent-linking?" + DatabaseIndexNameType.assessment + "=" + this.tech_id;
  }

  findRelatedDrillHoles() {
    var elasticSearchQueryBody: ElasticSearchQueryBody = {
      size: 1000,
      query: {
        bool: {
          must: [{ query_string: { query: this.tech_id } }]
        }
      },
      sort: undefined,
    };

    var postRequest : any = {
      indexes: "drill-hole",
      body: JSON.stringify(elasticSearchQueryBody)
    }

    this.http
      .post(environment.apim_url, postRequest, this.httpOptions).pipe(
        takeWhile(() => this.alive),
        tap(() => this.displayProgressSpinner = true),
        tap(() => this.spinnerWithoutBackdrop = true)
        )
      .subscribe((res: any) => {
        this.drillHoles$ = of(res.hits.hits);
        this.cd();

        setTimeout(()=> {
          this.loadOntarioExpandCollapse();
          this.displayProgressSpinner = false;
          this.spinnerWithoutBackdrop = false;
          this.changeDetectorRef.markForCheck();
        }, 500);
      });
  }
}